import React from "react";

import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import Beautyfloatingbutton from "../../components/beautyfloatingbutton";

import "./beautysupport.css";

import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default function SupportPage() {
  
  return (
    <>
      <Header />
      <Navbar />

      {/* ================= HERO ================= */}
      <section className="hero-section">
        <div className="hero-content slide-up">
          <h1>We're Here to Help You</h1>
          <p>
            Need assistance or have questions? Our support team is ready to assist
            you promptly and professionally.
          </p>
        </div>
      </section>

      {/* ================= QUICK HELP ================= */}
<section className="py-5 bg-theme">
  <div className="container">
    <h2 className="fw-bold text-center mb-4 slide-up">Quick Help</h2>

    <div className="quick-help-row">
      {[
        {
          icon: "bi-whatsapp",
          title: "WhatsApp Support",
          desc: "Chat with us instantly",
          value: "+91 9876543210",
          link: "https://wa.me/919876543210",
        },
        {
          icon: "bi-envelope-paper",
          title: "Email Support",
          desc: "We reply within 24 hours",
          value: "support@orrbiit.com",
          link: "mailto:support@orrbiit.com",
        },
        {
          icon: "bi-telephone",
          title: "Call Us",
          desc: "Talk directly for quick help",
          value: "+91 9876543210",
          link: "tel:+919876543210",
        },
      ].map((item, index) => (
        <div key={index} className="support-card">
          <i className={`bi ${item.icon}`}></i>
          <h6>{item.title}</h6>
          <p>{item.desc}</p>

          {/* Contact Info */}
          <a href={item.link} className="contact-link">
            {item.value}
          </a>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* ================= FAQ ================= */}
      <section className="py-5">
        <div className="container">
          <h2 className="fw-bold text-center mb-4 slide-up">
            Frequently Asked Questions
          </h2>

          <div className="faq-container">
            {[
              {
                q: "How do I book a home salon session?",
                a: "Go to Products page → choose service → book easily.",
              },
              {
                q: "What are your safety measures?",
                a: "We follow strict hygiene and sanitized equipment protocols.",
              },
              {
                q: "Can I reschedule?",
                a: "Yes, up to 24 hours before appointment.",
              },
              {
                q: "What payment methods?",
                a: "UPI, Cards, Net Banking supported.",
              },
            ].map((item, index) => (
              <details key={index} className="faq-card">
                <summary>{item.q}</summary>
                <p>{item.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* ================= CONTACT ================= */}
      <section className="py-5 bg-theme">
        <div className="container contact-container">
          <h2 className="fw-bold text-center mb-4 slide-up">Contact Us</h2>

          <form>
            <div className="mb-3">
              <label>Your Name *</label>
              <input type="text" className="form-control" required />
            </div>

            <div className="mb-3">
              <label>Phone Number *</label>
              <div className="input-group">
                <span className="input-group-text">+91</span>
                <input
                  type="tel"
                  className="form-control"
                  required
                  maxLength="10"
                />
              </div>
            </div>

            <div className="mb-3">
              <label>Email (optional)</label>
              <input type="email" className="form-control" />
            </div>

            <div className="mb-3">
              <label>Your Message *</label>
              <textarea className="form-control" rows="4" required></textarea>
            </div>

            <div className="text-center">
              <button className="btn custom-btn">Send Message</button>
            </div>
          </form>
        </div>
      </section>

      <Footer />
      <Beautyfloatingbutton />

      {/* CTA Section */}
    </>
  );
}